module.exports = __webpack_public_path__ + "static/media/dj.94a8005f.svg";